import { Component, Input } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import type { EnableLocationFailureReason } from '../../../../../core/domains/user/services/location-access.service';

/**
 * Compact alert matching Figma "Turn on device location"
 * (Open settings / Later) — shown when OS location is lost while using the app.
 */
@Component({
  selector: 'smatchy-device-location-off-alert',
  templateUrl: './device-location-off-alert.component.html',
  styleUrls: ['./device-location-off-alert.component.scss'],
  imports: [IonicModule, TranslateModule],
})
export class DeviceLocationOffAlertComponent {
  @Input() blockReason: EnableLocationFailureReason = 'location_services_disabled';

  constructor(private readonly modalController: ModalController) {}

  get titleKey(): string {
    return this.blockReason === 'permission_denied'
      ? 'LOCATION_PERMISSION_MODAL.PERMISSION_DENIED_TITLE'
      : 'LOCATION_PERMISSION_MODAL.LOCATION_SERVICES_TITLE';
  }

  get messageKey(): string {
    return 'LOCATION_PERMISSION_MODAL.DEVICE_ACCESS_REQUIRED_MESSAGE';
  }

  async openSettings(): Promise<void> {
    await this.modalController.dismiss({ blockReason: this.blockReason }, 'open_settings');
  }

  async later(): Promise<void> {
    await this.modalController.dismiss(undefined, 'cancel');
  }
}
